import { render, staticRenderFns } from "./ModalProcesarTerapia.vue?vue&type=template&id=72ca9816"
import script from "./ModalProcesarTerapia.vue?vue&type=script&lang=js"
export * from "./ModalProcesarTerapia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports